import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import Check from "@/components/svg/Check";

/**
 * @typedef {import("@prismicio/client").Content.ProjectBulletListSlice} ProjectBulletListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectBulletListSlice>} ProjectBulletListProps
 * @type {import("react").FC<ProjectBulletListProps>}
 */
const ProjectBulletList = ({ slice }) => {
  const { title, bullets } = slice.primary;
  const filledBullets = Array.isArray(bullets)
    ? bullets.filter((bullet) => isFilled.richText(bullet.text))
    : [];

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="flex w-full flex-col gap-10">
        {isFilled.richText(title) && (
          <PrismicRichText
            field={title}
            components={{
              heading2: ({ children }) => (
                <h2 className="h2-n md:h3-n md:dk text-bleu">{children}</h2>
              ),
              heading3: ({ children }) => (
                <h3 className="h2-n md:h3-n md:dk text-bleu">{children}</h3>
              ),
            }}
          />
        )}

        {filledBullets.length > 0 && (
          <ul className="flex w-full flex-col gap-10">
            {filledBullets.map((bullet, index) => (
              <li
                key={`bullet-${index}`}
                className="flex w-full items-center justify-center gap-3">
                <div className="flex min-w-0 flex-1 flex-col gap-4">
                  <PrismicRichText
                    field={bullet.text}
                    components={{
                      heading3: ({ children }) => <div>
                        <div className="pt-1 md:pt-0" >
                          <Check />
                        </div>
                        <h3 className="p-lg-n md:p-xl font-medium text-bleu">{children}</h3>
                      </div>,
                      heading4: ({ children }) => <div className="flex items-start md:items-center justify-start gap-3">
                        <div className="pt-1 md:pt-0" >
                          <Check />
                        </div>
                        <h4 className="p-lg-n md:p-xl font-medium text-bleu">{children}</h4>
                      </div>,
                      paragraph: ({ children }) => (
                        <p className="p-lg-n md:p-xl-n md:lt text-bleu">{children}</p>
                      )
                    }}
                  />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default ProjectBulletList;
